<styles-sidenav-content-spacer menuFeeds="true">
  <bread-crumb>
    <styles-bread-crumb icon="dataset" title="Search {{searchTerm ? (' - ' + searchTerm) : ''}}" #breadcrumb>
    </styles-bread-crumb>
  </bread-crumb>

  <styles-tabs-header>
    <styles-tab-header-content link="./search-results">
      <mat-icon> search </mat-icon>
      Search Results
    </styles-tab-header-content>
  </styles-tabs-header>
</styles-sidenav-content-spacer>
